const { cELM, guidGenerator, getAnswerVariableCssClass, httpGet, get } = require("../utils");
const Scroller = require("../components/scroller");
const Chat = require("../chat");
const Provider = require("../components/blocks/provider");
const Question = require("../components/blocks/question");
const UploaderControl = require("./uploader-control");

class FileUploaderModule {
  constructor(type, value) {
    this.type = type;
    this.value = value;
    this._files = null;
    this._timer = null;

    this.elements = {
      _questionBlock: null,
      _uploadContainerEl: null,
      _inputEl: null,
      _btnEl: null,
      _percentEl: null,
      _loadingBl: null,
      _answerBlockEl: null,
    };
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `component-block upload ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));

    let _qBl = null;

    _qBl = new Question({ data: value });
    this.elContainer.addELM(_qBl);
    this.elements._questionBlock = _qBl;

    const answerBlock = this.addAnswerBlock();
    this.elContainer.addELM(answerBlock);

    this.elements._answerBlockEl = answerBlock;

    this.control = new UploaderControl({ delegate: this, target: "google" });
  }

  addAnswerBlock() {
    const _self = this;
    const oBlock = cELM("div", "option-block controls");
    const _btnEl = cELM("div", "button", "Select File");
    const _inputEl = cELM("input", "input-file");

    _inputEl.setAttribute("multiple", false);
    // _inputEl.setAttribute("accept", "image/*,.pdf");
    _inputEl.setAttribute("type", "file");
    _inputEl.style.display = "none";

    const _uploadContainerEl = cELM("div", "inputs-wrapper");
    const _loadingBl = cELM("div", "loading-block");
    _loadingBl.style.display = "none";

    const _percentEl = cELM("div", "percent", "0%");
    _loadingBl.addELM(_percentEl);

    const _skipBtnEl = cELM("div", "button inactive", "Skip");
    const _row = cELM("div", "upload-actions");
    _row.addELM(_btnEl);
    _row.addELM(_skipBtnEl);

    _uploadContainerEl.addELM(_loadingBl);
    _uploadContainerEl.addELM(_row);

    _skipBtnEl.onclick = function(evt) {
      Chat.default.send(
        {
          id: (_self.value || {}).id,
          meta: { type: "unknown", fields: [] },
          status: "checked",
        },
        null,
        _self.elContainer,
      );
      _self.hideAnswers();
    };

    _inputEl.onchange = function(e) {
      if (this.files[0]) {
        _self._files = this.files;
        _self.control.queue(this);
        _self.control.processQueue();
      }
    };

    _btnEl.onclick = function(evt) {
      _inputEl.click();
    };

    oBlock.addELM(_uploadContainerEl);
    oBlock.addELM(_inputEl);

    this.elements._uploadContainerEl = _uploadContainerEl;
    this.elements._inputEl = _inputEl;
    this.elements._btnEl = _btnEl;
    this.elements._percentEl = _percentEl;
    this.elements._loadingBl = _loadingBl;

    return oBlock;
  }

  handle(value) {
    switch (value.format) {
      case "onfileupload-started":
        break;
      case "onfileupload-uploaded":
        this.handleProcessed(value);
        break;
      default:
        break;
    }
  }

  getELM() {
    return this.elContainer;
  }

  getHTML() {
    return this.elContainer;
  }

  reset() {}

  focus() {}

  handleProcessed(value) {
    const _self = this;
    // when upload completed and processed
    this._percent = 100;
    this._maxPercent = 100;
    clearInterval(this._interval);
    this.updateProgress();

    setTimeout(() => {
      this.elements._uploadContainerEl.style.display = "none";
      Chat.default.send({
        id: (_self.value || {}).id,
        status: "checked",
      });
    }, 800);
  }

  // callbacks
  onUpload(file) {
    const _self = this;
    // when upload starts
    this.elements._btnEl.style.display = "none";
    this.elements._loadingBl.style.display = "block";

    this._files[0].batchId = guidGenerator();
    Chat.default.send({
      id: (_self.value || {}).id,
      files: this._files,
      status: "start",
    });

    Scroller.scrollToEnd(0);
    this.initiateLoader();
  }

  onProgress(file, progress) {
    const _self = this;
    Chat.default.send({
      id: (_self.value || {}).id,
      file: { finalURL: file.finalURL, size: file.size },
      status: "uploading",
    });
  }

  onCompleted(file) {
    const _self = this;
    Chat.default.send(
      {
        id: (_self.value || {}).id,
        file: {
          finalURL: file.finalURL,
          mime: file.type,
          name: file.name,
          progress: 100,
          status: "completed",
        },
        status: "uploaded",
      },
      null,
      this.elContainer,
    );
  }

  onError(file, msg) {
    console.log(file, msg);
  }

  initiateLoader() {
    this._percent = 0;
    this._maxPercent = 99;

    const _self = this;

    this._interval = setInterval(function() {
      const inc = (_self._maxPercent - _self._percent) / 100;
      if (_self._percent < _self._maxPercent) {
        _self._percent += inc;
        _self.updateProgress();
      }

      if (_self.percent >= 100) {
        clearInterval(_self._interval);
      }
    }, 50);
  }

  updateProgress() {
    this.elements._percentEl.innerHTML = Math.round(this._percent) + "%";
  }

  hideAnswers() {
    this.elements._answerBlockEl.style.display = "none";
  }

  scrollToElement() {
    Scroller.scrollToElm(this);
  }
}

module.exports = FileUploaderModule;
